import React from 'react';
import { NumberInput } from 'hyperdb-utils';

const CancellationFeeForm = ({ cancellationFee, onChange }) => {
  return (
    <fieldset>
      <NumberInput
        label="Days until arrival *"
        name="days_until_arrival"
        value={ cancellationFee.days_until_arrival }
        onChange={ onChange.bind(null, 'days_until_arrival') }
      />
      <NumberInput
        label="Charge (%) *"
        name="value"
        value={ cancellationFee.value }
        onChange={ onChange.bind(null, 'value') }
      />
    </fieldset>
  );
};

export default CancellationFeeForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/cancellation-policy/components/CancellationFeeForm.jsx